declare var angular: any;

angular
  .module('PlatformExam')

  .config([
    '$injector',
    '$mdThemingProvider',
    '$mdIconProvider',
    function($injector, $mdThemingProvider, $mdIconProvider) {
      var EXAM = $injector.get('EXAM');
      var primaryColor;
      let accentPalette = 'orange';
      let extendedPalette = {};
      if (EXAM === 'toeic') {
        primaryColor = 'blue';
      } else if (EXAM === 'bulats') {
        primaryColor = 'green';
      } else if (EXAM === 'bright') {
        primaryColor = 'cyan';
      } else if (EXAM === 'delf') {
        primaryColor = 'blue';
        /*
         */
        primaryColor = 'red';
        accentPalette = 'myGreenPalette';

        extendedPalette = {
          '400': 'EE6C4D',
          '600': '#e24f2e',
          '900': 'ad371d'
        };
      } else if (EXAM === 'lerobert') {
        primaryColor = 'light-blue';

        extendedPalette = {
          '400': '2CBCFA',
          '600': '04A2EA',
          '900': '005DA0'
        };
      } else if (EXAM === 'linguaskill') {
        extendedPalette = {
          '400': '78CDE3',
          '600': '6cc2da',
          '900': '3591a8'
        };
        //primaryColor = "yellow";
        primaryColor = 'light-blue';
      } else {
        primaryColor = 'purple';
      }

      var myGreenPalette = $mdThemingProvider.extendPalette(primaryColor, {
        // whether, by default, text (contrast) on this palette should be dark or light
        // This is the default for the green palette
        contrastDefaultColor: 'light',
        ...extendedPalette
        // hues which contrast should be 'light' by default
        // 'contrastLightColors': ['400']
      });

      $mdThemingProvider.definePalette('myGreenPalette', myGreenPalette);

      $mdThemingProvider
        .theme('default')
        .primaryPalette('myGreenPalette', {
          default: '600', // by default use shade 400 from the pink palette for primary intentions
          'hue-1': '400', // use shade 100 for the <code>md-hue-1</code> class
          'hue-2': '600', // use shade 600 for the <code>md-hue-2</code> class
          'hue-3': '900' // use shade A100 for the <code>md-hue-3</code> class
        })
        .backgroundPalette('grey')
        // If you specify less than all of the keys, it will inherit from the
        // default shades
        .accentPalette(accentPalette, {
          default: '400' // use shade 200 for default, and keep all other shades the same
        });

      $mdIconProvider
        //.defaultIconSet('my/app/icons.svg')
        //index

        .icon('group_add', '/ng1/www/img/icons/group_add-black-18dp.svg')
        .icon('smartphone', '/ng1/www/img/icons/ic_smartphone_24px.svg')
        .icon('trending_up', '/ng1/www/img/icons/ic_trending_up_24px.svg')
        .icon('receipt', '/ng1/www/img/icons/ic_receipt_24px.svg')
        .icon('extension', '/ng1/www/img/icons/ic_extension_24px.svg')
        .icon('lock', '/ng1/www/img/icons/lock-black-18dp.svg')
        .icon('arrow_forward', '/ng1/www/img/icons/ic_arrow_forward_24px.svg')
        .icon(
          'arrow_down',
          '/ng1/www/img/icons/ic_keyboard_arrow_down_black_24px.svg'
        )
        .icon('perm_identity', '/ng1/www/img/icons/ic_perm_identity_24px.svg')
        .icon('chat', '/ng1/www/img/icons/ic_chat_24px.svg')
        .icon('done_all', '/ng1/www/img/icons/ic_done_all_24px.svg')
        .icon('done', '/ng1/www/img/icons/ic_done_48px.svg')

        .icon('publish', '/ng1/www/img/icons/publish-24px.svg')
        .icon('appmenu', '/ng1/www/img/icons/ic_menu_24px.svg')

        //action
        .icon('cached', '/ng1/www/img/icons/ic_cached_24px.svg')
        .icon('pageview', '/ng1/www/img/icons/ic_pageview_24px.svg')
        .icon('help', '/ng1/www/img/icons/ic_help_24px.svg')
        .icon(
          'lightbulb_outline',
          '/ng1/www/img/icons/ic_lightbulb_outline_24px.svg'
        )
        .icon('speaker_notes', '/ng1/www/img/icons/ic_speaker_notes_24px.svg')
        .icon('delete', '/ng1/www/img/icons/ic_delete_24px.svg')
        .icon('track_changes', '/ng1/www/img/icons/ic_track_changes_24px.svg')
        .icon('check_circle', '/ng1/www/img/icons/check_circle-24px.svg')
        .icon('language', '/ng1/www/img/icons/language.svg')

        //editor
        .icon('format_quote', '/ng1/www/img/icons/ic_format_quote_24px.svg')

        // av
        .icon('play_arrow', '/ng1/www/img/icons/ic_play_arrow_24px.svg')
        .icon('pause', '/ng1/www/img/icons/ic_pause_24px.svg')

        .icon(
          'play_circle_fill',
          '/ng1/www/img/icons/ic_play_circle_fill_24px.svg'
        )
        .icon(
          'pause_circle_fill',
          '/ng1/www/img/icons/ic_pause_circle_fill_24px.svg'
        )

        .icon('add', '/ng1/www/img/icons/ic_add_24px.svg')
        .icon('remove', '/ng1/www/img/icons/ic_remove_24px.svg')
        .icon('check', '/ng1/www/img/icons/ic_check_24px.svg')
        .icon('close', '/ng1/www/img/icons/ic_close_24px.svg')
        .icon('settings', '/ng1/www/img/icons/ic_settings_24px.svg')
        .icon('info_outline', '/ng1/www/img/icons/ic_info_outline_24px.svg')

        .icon('search', '/ng1/www/img/icons/ic_search_24px.svg')
        .icon('more_vert', '/ng1/www/img/icons/ic_more_vert_24px.svg')
        .icon(
          'power_settings_new',
          '/ng1/www/img/icons/ic_power_settings_new_24px.svg'
        )
        .icon('settings', '/ng1/www/img/icons/ic_settings_24px.svg')

        .icon('volume_mute', '/ng1/www/img/icons/ic_volume_mute_24px.svg')
        .icon('volume_up', '/ng1/www/img/icons/ic_volume_up_24px.svg')

        //communication
        .icon('email', '/ng1/www/img/icons/ic_email_24px.svg')
        .icon(
          'import_contacts',
          '/ng1/www/img/icons/ic_import_contacts_24px.svg'
        )

        //content
        .icon(
          'remove_circle_outline',
          '/ng1/www/img/icons/ic_remove_circle_outline_24px.svg'
        )

        //image
        .icon('edit', '/ng1/www/img/icons/ic_edit_24px.svg')

        //action
        .icon('subject', '/ng1/www/img/icons/ic_subject_24px.svg')
        .icon('spellcheck', '/ng1/www/img/icons/ic_spellcheck_24px.svg')

        // social
        .icon('share', '/ng1/www/img/icons/ic_share_24px.svg')

        //navigation
        .icon('arrow_back', '/ng1/www/img/icons/ic_arrow_back_24px.svg')
        .icon('refresh', '/ng1/www/img/icons/refresh-black-18dp.svg');
    }
  ]);
